import React, { useState } from "react";
import useShipping from "./useShipping"; // adjust path if needed
import ConfirmationModal from "./ConfirmationModal";
import CustomLoading from "../../../utils/LoadingIndicator/CustomLoading";

function ListShipping({ onSetActiveTab }) {
  const {
    shippingData,
    isGettingShippingData,
    errorGettingShippinData,
    deleteShippingFn,
    isDeletingShipping,
  } = useShipping();

  const [deletingId, setDeletingId] = useState(null);
  const [confirmModal, setConfirmModal] = useState({
    open: false,
    shipping: null,
  });

  if (isGettingShippingData) return <CustomLoading />;
  if (errorGettingShippinData)
    return <div className="text-red-500">Error loading shipping data.</div>;

  const handleDelete = (shipping) => {
    setConfirmModal({ open: true, shipping });
  };

  const confirmDelete = () => {
    setDeletingId(confirmModal.shipping._id);
    deleteShippingFn(confirmModal.shipping._id, {
      onSettled: () => {
        setDeletingId(null);
        setConfirmModal({ open: false, shipping: null });
      },
    });
  };

  const cancelDelete = () => {
    setConfirmModal({ open: false, shipping: null });
  };

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">Shipping Options</h2>
        <button
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors"
          onClick={() => onSetActiveTab("create")}
        >
          + New Shipping
        </button>
      </div>
      <div className="grid gap-6">
        {shippingData && shippingData?.shippingOptions?.length > 0 ? (
          [...shippingData?.shippingOptions].reverse().map((shipping) => (
            <div
              key={shipping._id}
              className="bg-white rounded shadow p-6 flex flex-col md:flex-row md:items-center md:justify-between"
            >
              <div className="flex-1 space-y-2">
                <div className="flex items-center gap-4 text-lg font-semibold">
                  <span>{shipping.governorate}</span>
                  <span className="text-gray-500">/</span>
                  <span className="text-gray-700">{shipping.city}</span>
                </div>
                <div className="text-sm text-gray-700 flex flex-wrap gap-4">
                  <span>
                    <span className="font-medium">Price:</span> {shipping.price}{" "}
                    EGP
                  </span>
                  <span>
                    <span className="font-medium">Days to Deliver:</span>{" "}
                    {shipping.daysToDeliver} days
                  </span>
                  <span className="text-gray-400 text-xs">
                    Created: {new Date(shipping.createdAt).toLocaleDateString()}
                  </span>
                </div>
              </div>
              <div className="flex flex-col gap-2 mt-4 md:mt-0 md:ml-6 items-end">
                <button
                  className="px-4 py-2 rounded bg-red-600 text-white hover:bg-red-700 transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
                  onClick={() => handleDelete(shipping)}
                  disabled={isDeletingShipping && deletingId === shipping._id}
                >
                  {isDeletingShipping && deletingId === shipping._id
                    ? "Deleting..."
                    : "Delete"}
                </button>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center py-12 text-gray-500">
            No shipping options found.
          </div>
        )}
      </div>

      {confirmModal.open && (
        <ConfirmationModal
          isDeletingShipping={isDeletingShipping}
          cancelDelete={cancelDelete}
          confirmDelete={confirmDelete}
          confirmModal={confirmModal}
        />
      )}
    </div>
  );
}

export default ListShipping;
